import { IconType } from "react-icons/lib";
import { TbCrown, TbFriends, TbGlassChampagne, TbUser } from "react-icons/tb";

import { softColors } from "./colors";

export type PatientTypeItem = {
    component: () => IconType;
    label: string;
    hover: string;
    bg: string;
    text: string;
    tooltip: {
        title: string;
        description: string;
    };
    values: string[];
};

export const patientTypes: PatientTypeItem[] = [
    {
        component: () => TbUser,
        label: "Standart",
        tooltip: {
            title: "Standart hasta",
            description: "Genel bakım gereksinimi olan, standart hizmetlerle seyahat eden hasta.",
        },
        ...softColors.brown,
        values: ["normal", "Normal Patient", "Normal"],
    },
    {
        component: () => TbCrown,
        label: "VIP",
        tooltip: {
            title: "VIP hasta (VIP-Angebot)",
            description: "Premium avantajlar ve öncelikli destek ile özel erişim sunulacak kişi.",
        },
        ...softColors.amber,
        values: ["VIP-Angebot", "VIP", "Angebot"],
    },
    {
        component: () => TbUser,
        label: "Normal",
        tooltip: {
            title: "Normal hasta",
            description: "Standart hasta",
        },
        ...softColors.brown,
        values: ["VIP-Angebot", "Bonusdeal"],
    },
    {
        component: () => TbGlassChampagne,
        label: "Deluxe",
        tooltip: {
            title: "Deluxe Oda",
            description: "Geliştirilmiş ve ekstra ayrıcalıklarla daha zengin bir deneyim sunulacak kişi.",
        },
        ...softColors.purple,
        values: ["Deluxe", "Deluxe Zimmer"],
    },
    {
        component: () => TbFriends,
        label: "Aile/Arkadaş",
        tooltip: {
            title: "Aile, arkadaş veya çalışan yakını",
            description: "Şirketimizde çalışan kişilerin aile veya arkadaşı olan kişi.",
        },
        ...softColors.green,
        values: ["Family & Friend & MA", "Family & Friends & MA", "MA", "Family", "Friends & Prominente"],
    },
    {
        component: () => TbFriends,
        label: "Özel İndirimli",
        tooltip: {
            title: "Özel İndirimli hasta",
            description: "Özel indirim ve promosyon fırsatları sunan hasta.",
        },
        ...softColors.orange,
        values: ["Bonus Deal", "Bonusdeal"],
    },
    {
        component: () => TbCrown,
        label: "VIP",
        tooltip: {
            title: "VIP",
            description: "Premium avantajlar ve öncelikli destek ile özel erişim sunulacak kişi.",
        },
        ...softColors.amber,
        values: ["Influencer", "Influencer "],
    },
];
